import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_FILE_INVOICE: GlameraIconDefinition = {
  name: 'file-invoice',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-file-invoice-body">
      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
      <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
      <path class="glm-file-invoice-line glm-file-invoice-line-1" d="M8 10h4"></path>
      <path class="glm-file-invoice-line glm-file-invoice-line-2" d="M8 13h3"></path>
      <rect class="glm-file-invoice-box" x="8" y="15" width="8" height="4" rx="1"></rect>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-file-invoice-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './file-invoice.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FileInvoiceIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_FILE_INVOICE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
